import React, { useEffect, useState } from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getCaseTypes } from '../API/TdsatApi';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#121212',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.3125rem',
    textAlign: 'left',
    marginBottom: '0.2rem',
  },
  
}));

const CaseTypeInput = ({
  caseType = '', 
  onChange, 
  isRequired=false,
  size='medium', 
  type = 'MainCase', 
  isLabel = true, 
  isInlineLabel = true,
  label = 'Case Type',
  error = null,
  name = 'case_type',
  formControlStyles,
}) => {
  const classes = useStyles();

  const [caseTypeOptions, setCaseTypeOptions] = useState([]);

  useEffect(() => {
    getCaseTypes(type).then((res) => {
      setCaseTypeOptions(res.data);
    });
  },[])
  
  return (
    <>
      <FormControl required={isRequired} fullWidth margin="none" variant="outlined" size={size} style={formControlStyles}>
        {isLabel && (
          isInlineLabel ? (
            <InputLabel id='case_type'>{label}</InputLabel>
          ) : (
            <Typography className={classes.label}>{label}</Typography>
          )
        )}
        <Select
          name={name}
          value={caseType}
          onChange={onChange}
          labelId='case_type'
          label={isInlineLabel && label}
        >
          <MenuItem>Select</MenuItem>
          {caseTypeOptions?.map((item, index)=>{
            return (
              <MenuItem key={index} value={item?.code}>{item?.name}</MenuItem>
            )
          })}
        </Select>
        {error && (
          <FormHelperText style={{color:'red', margin:0}}>{error}</FormHelperText>
        )}
      </FormControl>
    </>
  );
};

export default CaseTypeInput;
